import {useDispatch, useSelector} from 'react-redux'

import {trackEvent} from '../../analytics/modules/actions'
import {Action, Category, Entity, Team} from '../../analytics/types/Events'
import {getUser} from '../../auth/modules/selectors'
import {useFetchAclQuery} from '../services/index'

/**
 * Component that fetches ACL (Access Control List) decision for a user and tracks the result
 * @param params - Parameters object
 * @param params.anonymousId - Anonymous identifier for the user
 * @returns null - This component doesn't render anything
 */
export const FetchAclDecision = ({anonymousId}: {anonymousId: string}) => {
  const user = useSelector(getUser)
  const dispatch = useDispatch()

  // Calls should be skipped when users is not authenticated
  const shouldSkipCall = Boolean(!user)

  const {data} = useFetchAclQuery(anonymousId, {skip: shouldSkipCall})

  if (data) {
    dispatch(
      trackEvent({
        category: Category.System,
        entity: Entity.ACL,
        action: Action.Served,
        team: Team.Retention,
        payload: {
          isCustomer: data.isCustomer,
          aclDecision: data.aclDecision
        }
      })
    )
  }

  return null
}
